import { format, isValid, parseISO } from 'date-fns'

import { toLocaleString3 } from '../strings'

// Status considerados: 4 (Aguardando Aprovação) e 5 (Recusado)
const STATUS_AGUARDANDO = 4
const STATUS_RECUSADO = 5

export interface IPurchaseOrdersApprovalByDate {
  key: string // yyyy-MM-dd (ordenável)
  label: string // dd/MM/yyyy
  aguardando: number
  recusado: number
}

// parseISO interpreta 'yyyy-MM-dd' no fuso local (new Date() usaria UTC e
// poderia deslocar o dia)
const parseOrderDate = (value: unknown): Date | null => {
  if (!value) return null
  const date = value instanceof Date ? value : parseISO(String(value))
  return isValid(date) ? date : null
}

// Parser único do gráfico e da tabela: agrupa por dia (chave ISO), ordena
// cronologicamente e só formata no fim
export const groupPurchaseOrdersApprovalByDate = (
  data: any[]
): IPurchaseOrdersApprovalByDate[] => {
  const byDate = new Map<string, IPurchaseOrdersApprovalByDate>()

  ;(Array.isArray(data) ? data : []).forEach((order: any) => {
    if (
      order?.statusPedido !== STATUS_AGUARDANDO &&
      order?.statusPedido !== STATUS_RECUSADO
    ) {
      return
    }

    const date = parseOrderDate(order.dataCriacao)
    if (!date) return

    const key = format(date, 'yyyy-MM-dd')
    const entry = byDate.get(key) || {
      key,
      label: format(date, 'dd/MM/yyyy'),
      aguardando: 0,
      recusado: 0
    }
    const total = Number(order.totalPedidos) || 0

    if (order.statusPedido === STATUS_AGUARDANDO) entry.aguardando += total
    else entry.recusado += total

    byDate.set(key, entry)
  })

  return Array.from(byDate.values()).sort((a, b) => a.key.localeCompare(b.key))
}

export const overviewPurchaseOrdersApprovalParser = (data: any[]): any[] =>
  groupPurchaseOrdersApprovalByDate(data).map(row => ({
    data: row.label,
    aguardandoAprovacao: toLocaleString3(row.aguardando),
    recusado: toLocaleString3(row.recusado)
  }))

export const overviewPurchaseOrdersApprovalParserFooter = (
  data: any[]
): any[] => {
  const totals = groupPurchaseOrdersApprovalByDate(data).reduce(
    (acc, row) => ({
      aguardando: acc.aguardando + row.aguardando,
      recusado: acc.recusado + row.recusado
    }),
    { aguardando: 0, recusado: 0 }
  )

  return [
    {
      data: 'TOTAL',
      aguardandoAprovacao: toLocaleString3(totals.aguardando),
      recusado: toLocaleString3(totals.recusado)
    }
  ]
}
